import { gsap } from 'gsap';
import { driftAnimationNames } from '../driftCore/constants';

class DriftDrawerService {
  setRiderSpine(riderSpine) {
    this.riderSpine = riderSpine;
  }

  setBgSpine(bgSpine) {
    this.bgSpine = bgSpine;
  }

  setSmokeSpine(smokeSpine) {
    this.smokeSpine = smokeSpine;
  }

  setWinAmountText(winAmountText) {
    this.winAmountText = winAmountText;
  }

  setCashOutGraphic(cashOutGraphic) {
    this.cashOutGraphic = cashOutGraphic;
  }

  playBackGroundAnimation() {
    this.bgSpine.play('animation', true);
  }

  playRiderIdleDefault() {
    this.riderSpine.play(driftAnimationNames.idleDefault, true);
  }

  playRiderIdle() {
    this.riderSpine.play(driftAnimationNames.riderIdle, true);
  }

  playRiderLose(event) {
    this.riderSpine.play(driftAnimationNames.riderLose);
    if (event) {
      this.riderSpine.addListener('complete', event, null, driftAnimationNames.riderLose, true);
    }
  }

  playRiderBet(event) {
    this.riderSpine.play(driftAnimationNames.riderBet);
    if (event) {
      this.riderSpine.addListener('complete', event, this.riderSpine, driftAnimationNames.riderBet);
    }
  }

  playSmokeBet(event) {
    this.smokeSpine.visible = true;
    this.smokeSpine.play(driftAnimationNames.smokeBet);
    if (event) {
      this.smokeSpine.addListener(
        'complete',
        event,
        this.smokeSpine,
        driftAnimationNames.smokeBet,
        true
      );
    }
  }

  playSmokeIdle() {
    this.smokeSpine.visible = true;
    this.smokeSpine.play(driftAnimationNames.smokeIdle, true);
  }

  resetRider() {
    this.riderSpine.state.clearTracks();
    this.riderSpine.skeleton.setToSetupPose();
  }

  resetSmoke() {
    this.smokeSpine.state.clearTracks();
    this.smokeSpine.skeleton.setToSetupPose();
    this.smokeSpine.visible = false;
  }

  resetAnimationState() {
    this.resetRider();
    this.resetSmoke();
    // this.containers[driftGameLayers.winAmount].children = [];
  }

  removeCashOutGraphic(callBack = () => {}) {
    gsap.to(this.cashOutGraphic.scale, {
      duration: 0.1,
      x: 0,
      y: 0,
      ease: 'none',
      pixi: {
        alpha: 0,
      },
      onComplete: callBack,
    });
  }

  cashOutTextAnim() {
    gsap.to(this.winAmountText.scale, {
      duration: 0.2,
      x: 1.5,
      y: 1.5,
      onComplete: () => {
        gsap.to(this.winAmountText.scale, {
          duration: 0.2,
          x: 1,
          y: 1,
        });
      },
    });
  }

  loseTextAnim(callBack = () => {}) {
    gsap.to(this.winAmountText.scale, {
      duration: 0.1,
      delay: 1,
      ease: 'none',
      x: 0,
      y: 0,
      onComplete: callBack,
    });
  }

  showWinAmountAnim() {
    gsap.to(this.winAmountText.scale, {
      duration: 0.1,
      ease: 'none',
      pixi: {
        scale: 1,
      },
      x: 1,
      y: 1,
    });
  }

  showCashOutContainer(callBack = () => {}) {
    gsap.to(this.winAmountText.scale, {
      duration: 0.2,
      pixi: {
        scale: 1.5,
      },
      onComplete: () => {
        gsap.to(this.winAmountText.scale, {
          duration: 0.2,
          delay: 1,
          pixi: {
            scale: 1,
          },
          onComplete: () => {
            callBack();
          },
        });
      },
    });
    this.cashOutTextAnim();
  }

  removeWinAmountAnim(callBack = () => {}) {
    this.removeCashOutGraphic();
    gsap.to(this.winAmountText.scale, {
      duration: 0.1,
      delay: 1,
      pixi: {
        scale: 0,
      },
      ease: 'none',
      x: 0,
      y: 0,
      onComplete: callBack,
    });
  }
}

export const driftDrawerService = new DriftDrawerService();
